import '../scss/pages/notre_histoire.scss';

import AOS from 'aos';

jQuery(function ($) {
    /*------------------------------------------------------------
         0.1. Timline animation
     ------------------------------------------------------------*/
    const timeLineBlock = $(".oph-timeline .item");
    let currentAmount = 5;
    const timeLineItemsAmount = timeLineBlock.length;
    AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
        initClassName: "aos-init", // class applied after initialization
        animatedClassName: "aos-animate", // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 120, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 1500, // values from 0 to 3000, with step 50ms
        easing: "ease", // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    var heightTimeline;
    timeLineBlock
        .slice(currentAmount, timeLineItemsAmount)
        .addClass("is-hidden");
    $(".oph-timeline__content__loadmore, .oph-timeline__year__last-year").on(
        "click",
        function (e) {
            e.preventDefault();
            $(".lds-ellipsis").addClass("show");
            $(".text-load").addClass("hide");
            setTimeout(function () {
                var heightUl = $(".oph-timeline").offset().top;
                var heightLi = $(".oph-timeline li:last-child ").offset().top;
                currentAmount = currentAmount + 5;
                timeLineBlock.slice(0, currentAmount).removeClass("is-hidden");
                $(".lds-ellipsis").removeClass("show");
                $(".text-load").removeClass("hide");
                if (currentAmount >= timeLineItemsAmount) {
                    $(
                        ".oph-timeline__content__loadmore ,  .oph-timeline__year.under-loadmore"
                    ).hide();
                }
                heightTimeline = heightLi - heightUl + 360;

                // $(".timeline-before").css({ height: heightTimeline + "px" });
            }, 1500);
        }
    );
    /*------------------------------------------------------------
         0.2. Truncate text
     ------------------------------------------------------------*/
    const truncateTextTimLine = () => {
        var length = 250;
        // var breakPoint = 991;
        var truncateTimeLineText = $(
            ".oph-timeline__content .oph-timeline__content__des"
        );
        truncateTimeLineText.each(function () {
            var _this = $(this);
            var originalHtml = _this.attr("data-content");
            var originalText = _this.text();
            _this
                .parent()
                .find(".oph-timeline__content__readmore")
                .on("click", function () {
                    _this.html(originalHtml);
                    $(this).remove();
                    return false;
                });
            var truncatedText =
                $.trim(originalText)
                    .substring(0, length)
                    .split(" ")
                    .slice(0, -1)
                    .join(" ") + "... ";
            _this.html(truncatedText);
        });
    };
    truncateTextTimLine();
});
